export const Perfis = {
  CADASTRAR_PERFIL: "Cadastrar novo perfil",
  CONFIRMAR_EXCLUIR: "Tem certeza que deseja excluir este perfil?",
  NOME: "Nome",
  PERFIS: 'Perfis',
  PERFIS_DESCRICAO: 'Nessa tela você pode gerenciar perfis.',
  PERFIL_CADASTRADO_SUCESSO: "Perfil cadastrado com sucesso",
  PERFIL_EXCLUIDO_SUCESSO: "Perfil excluído com sucesso",
  RESTRINGIR_PAINEL_PROFESSOR: "Restringir painel de professor",
};
